<script setup lang="ts">
import SidebarComponent from "../components/SidebarComponent.vue";
</script>
<template>
  <SidebarComponent />
</template>
